export default __webpack_public_path__ + "static/media/slider1-right.e68372b2.svg";